export var Midday;
(function (Midday) {
    Midday["AM"] = "\uC624\uC804";
    Midday["PM"] = "\uC624\uD6C4";
})(Midday || (Midday = {}));
